<template>
  <v-container>
    <v-card>
      <v-card-text style="padding: 0px">
        <template>
          <v-toolbar color="primary" light>
            <v-toolbar-title class="white--text">Products</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                color="white"
                dark
                flat
                @click="
                  dialog = true;
                  $refs.productTabs.callSlider();
                "
                :disabled="!vid"
                >Add New</v-btn
              >
            </v-toolbar-items>
          </v-toolbar>
        </template>
        <div>
          <v-toolbar flat color="white" dense style="margin-bottom: 0px">
            <v-btn color="success" small @click="loadProducts()"
              ><v-icon>mdi-refresh</v-icon> Refresh</v-btn
            >
            <v-btn
              color="danger"
              class="white--text"
              small
              @click="deleteProducts()"
              :disabled="!selectedProducts.length > 0"
              ><v-icon>mdi-delete</v-icon> Delete</v-btn
            >
            <v-btn
              color="primary"
              small
              @click="setEditProduct()"
              :disabled="!(selectedProducts.length == 1)"
              ><v-icon>mdi-lead-pencil</v-icon> Edit</v-btn
            >
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-overflow-btn
                :items="categoriesItems"
                item-text="name"
                item-value="id"
                label="Category"
                return-object
                v-model="category"
                hide-details
                @input="loadProducts()"
                style="width: 200px"
                flat
                color="green"
              ></v-overflow-btn>
              <div style="width: 200px">
                <v-text-field
                  v-model="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </div>
            </v-toolbar-items>
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :items="products"
            :search="search"
            :loading="true"
            item-key="id"
            v-model="selectedProducts"
            select-all
            dense
            class="elevation-1"
          >
            <template slot="progress">
              <v-progress-linear color="blue" indeterminate />
            </template>
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-primary text--darken-3"
                v-text="header.text"
              ></span>
            </template>

            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  v-model="props.selected"
                  color="primary"
                  hide-details
                ></v-checkbox>
              </td>
              <td>
                <img
                  :src="props.item.image"
                  style="width: 75px; height: 75px; object-fit: cover"
                />
              </td>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.price }}</td>
              <td>{{ props.item.discount }}%</td>
              <td class="text-xs-center text-md-center">
                <v-switch
                  v-model="props.item.available"
                  color="primary"
                  class="v-input--reverse"
                  style="justify-content: center"
                  hide-details
                  @change="updateAvailable(props.item.id, props.item.available)"
                >
                  <template slot="label">
                    <span class="mr-1">Available</span>
                  </template>
                </v-switch>
                <v-switch
                  v-model="props.item.featured"
                  color="primary"
                  class="v-input--reverse"
                  style="justify-content: center"
                  hide-details
                  @change="updateFeatured(props.item.id, props.item.featured)"
                >
                  <template slot="label">
                    <span class="mr-1">Featured</span>
                  </template>
                </v-switch>
              </td>

              <td>
                <v-data-table
                  :items="props.item.variants"
                  hide-actions
                  hide-headers
                >
                  <template slot="items" slot-scope="{ item }">
                    <td>{{ item.name }}</td>
                    <td>
                      <v-chip small :key="val.name" v-for="val in item.values">
                        <strong>{{ val.name }}</strong
                        >&nbsp;
                        <span>(Rs. {{ val.price }})</span>
                      </v-chip>
                    </td>
                  </template>
                </v-data-table>
              </td>
            </template>
          </v-data-table>
        </div>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title class="pb-0 d-flex text-primary">
          <span class="headline"
            >{{ editProduct ? 'Edit' : 'New' }} Product</span
          >
          <span class="text-xs-right"
            ><v-icon @click="cancel()">mdi-close</v-icon></span
          >
        </v-card-title>
        <v-card-text>
          <v-form v-model="valid" style="min-height: 50vh">
            <v-tabs v-model="step" slider-color="primary" ref="productTabs">
              <v-tab :key="0" disabled> Product Details </v-tab>

              <v-tab :key="1" disabled> Variants </v-tab>

              <v-tab :key="2" disabled> Images </v-tab>
              <v-tab-item :key="0">
                <v-container grid-list-md>
                  <v-layout row wrap>
                    <v-flex xs6 sm6 md6>
                      <v-text-field
                        label="Name*"
                        :rules="rules.required"
                        required
                        v-model="product.name"
                      ></v-text-field>

                      <v-select
                        v-model="product.category_id"
                        :items="categories"
                        item-text="name"
                        item-value="id"
                        label="Category"
                        small
                        :rules="rules.required"
                      ></v-select>

                      <v-text-field
                        label="Price*"
                        :rules="rules.required"
                        type="number"
                        required
                        v-model.number="product.price"
                      ></v-text-field>
                      <v-text-field
                        label="Weight (gms)"
                        type="number"
                        required
                        v-model.number="product.weight"
                      ></v-text-field>
                      <v-text-field
                        label="Discount%"
                        type="number"
                        v-model.number="product.discount"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-switch
                        v-model="product.available"
                        label="Available"
                        color="success"
                      ></v-switch>
                      <v-switch
                        v-model="product.featured"
                        label="Featured"
                        color="success"
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="product.description"
                        placeholder="Describe product in few words."
                        auto-grow
                        label="Description"
                        required
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-tab-item>
              <v-tab-item :key="1">
                <v-container grid-list-md>
                  <v-layout row wrap>
                    <v-flex xs12 d-flex align-content-space-between>
                      <v-spacer></v-spacer>
                      <v-spacer></v-spacer>
                      <v-spacer></v-spacer>
                      <v-btn
                        dense
                        small
                        outline
                        style="width: 30px"
                        color="primary"
                        @click="variantDialog = true"
                        ><v-icon>mdi-plus</v-icon></v-btn
                      >
                    </v-flex>
                    <template v-for="(v, index) in variants">
                      <v-flex xs3 :key="index + 'a'">
                        <v-text-field
                          label="Label*"
                          :rules="rules.required"
                          required
                          readonly
                          v-model="v.name"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs3 :key="index + 'b'">
                        <v-text-field
                          label="Display"
                          required
                          readonly
                          v-model="v.display"
                        ></v-text-field>
                      </v-flex>
                      <v-flex :key="index + 'f'" xs4>
                        <v-chip small :key="val.name" v-for="val in v.values">
                          <strong>{{ val.name }}</strong
                          >&nbsp;
                          <span>(Rs. {{ val.price }})</span>
                        </v-chip>
                      </v-flex>
                      <v-flex class="text-xs-center" xs1 :key="index + 'e'">
                        <v-btn
                          round
                          fab
                          small
                          color="blue"
                          @click="
                            variant = v;
                            editVariant = true;
                            variantDialog = true;
                            editVariantIndex = index;
                          "
                          ><v-icon>mdi-pencil</v-icon></v-btn
                        >
                      </v-flex>
                      <v-flex class="text-xs-center" xs1 :key="index + 'd'">
                        <v-btn
                          round
                          fab
                          small
                          color="red"
                          @click="removeVariant(index)"
                          ><v-icon>mdi-minus</v-icon></v-btn
                        >
                      </v-flex>
                    </template>
                  </v-layout>
                </v-container>
              </v-tab-item>
              <v-tab-item :key="2">
                <input
                  type="file"
                  style="display: none"
                  ref="fileinput"
                  @change="addImage($event.target.files[0])"
                />
                <v-container grid-list-md>
                  <v-layout row wrap>
                    <v-flex xs6 md6 :key="i" v-for="(img, i) in images">
                      <div class="d-flex space-between">
                        <div>
                          <input
                            type="radio"
                            name="main"
                            :checked="img.main"
                            @change="updateMainImg($event, img)"
                          />
                          Main
                        </div>
                        <div class="text-xs-right">
                          <v-icon color="red" @click="images.splice(i, 1)"
                            >mdi-delete</v-icon
                          >
                        </div>
                      </div>
                      <v-img
                        :src="img.url ? img.url : imgUrl(img.file)"
                        height="150px"
                        aspect-ratio="2"
                      ></v-img>
                    </v-flex>

                    <v-flex xs6 md6>
                      <div class="d-flex space-between">
                        <div></div>
                        <div>
                          <v-icon></v-icon>
                        </div>
                      </div>
                      <v-layout
                        align-center
                        justify-center
                        style="height: 150px"
                      >
                        <v-flex class="text-xs-center" style="cursor: pointer">
                          <div @click="$refs.fileinput.click()">
                            <v-icon large>mdi-plus</v-icon>
                          </div>
                          <span> add new image </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-tab-item>
            </v-tabs>
          </v-form>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            small
            outline
            @click.native="step > 0 ? (step -= 1) : cancel()"
            >{{ step > 0 ? 'Prev' : 'Close' }}</v-btn
          >
          <v-btn
            :disabled="!valid || uploading || (step === 2 && !images.length)"
            small
            color="primary darken-1 white--text"
            @click.native="step < 2 ? (step += 1) : submit()"
            >{{ step < 2 ? 'Next' : 'Save' }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <variantModal
      v-model="variantDialog"
      :edit="editVariant"
      :variant="variant"
      @addVariant="addVariant($event)"
      @cancel="
        editVariant = false;
        variantDialog = false;
      "
    ></variantModal>
    <v-dialog v-model="dialog2" max-width="400px">
      <v-card>
        <v-card-title class="red--text"> Warning !! </v-card-title>
        <v-card-text class="pt-0">
          Error: Something went wrong... Please try again.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn color="blue" flat @click="dialog2 = false">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="galleryDialog" width="800">
      <v-toolbar dense style="margin-bottom: 0px">
        <v-toolbar-title>Select Image</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn
            color="primary"
            flat
            @click="galleryDialog = false"
            v-if="imgSelected"
            >Ok</v-btn
          >
        </v-toolbar-items>
      </v-toolbar>
      <v-tabs centered v-if="Object.keys(gallery).length > 0">
        <v-tabs-slider color="primary"></v-tabs-slider>

        <v-tab
          v-for="(tab, i) in Object.keys(gallery)"
          :key="i"
          :href="'#tab-' + i"
        >
          {{ tab }}
        </v-tab>

        <v-tab-item
          v-for="(imgs, c, i) in gallery"
          :key="i"
          :value="'tab-' + i"
        >
          <v-card flat>
            <v-card-text>
              <v-container grid-list-sm fluid pa-1>
                <v-layout row wrap>
                  <v-flex v-for="img in imgs" :key="img" xs3 d-flex>
                    <v-card flat tile class="d-flex">
                      <v-img :src="img" aspect-ratio="1" class="grey lighten-2">
                        <template v-if="imgSelected === img">
                          <v-layout
                            fill-height
                            align-center
                            justify-center
                            style="background: rgba(0, 0, 0, 0.5)"
                            ma-0
                          >
                            <v-icon class="mdi-48px" color="green"
                              >mdi-check</v-icon
                            >
                          </v-layout>
                        </template>
                      </v-img>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-dialog>
  </v-container>
</template>
<script type="text/javascript">
import api from '@/api';
import VImageInput from 'vuetify-image-input';
import variantModal from '@/components/variantModal.vue';
export default {
  components: { variantModal },
  data() {
    return {
      search: '',
      imageData: '',
      uploading: false,
      galleryDialog: false,
      imgSelected: '',
      selectedProducts: [],
      category: { name: 'Category', id: 'all' },
      categories: [],
      categoriesItems: [{ name: 'all', id: 'all' }],
      progress: 0,
      products: [],
      headers: [],
      images: [],
      gallery: {},
      deletedId: '',
      dialog: false,
      variantDialog: false,
      editVariant: false,
      editVariantIndex: -1,
      editProduct: false,
      variant: {},
      step: 0,
      rules: {
        required: [v => /^(?!\s*$).+/.test(v) || 'This field Cannot be empty.'],
        price: [v => /^\d+(,\d{1,2})?$/.test(v) || 'Enter valid price'],
        discount: [
          v => (/^\d+(,\d{1,2})?$/.test(v) && v <= 100) || 'Enter valid value',
        ],
      },
      product: {
        cid: '',
        picture: '',
        file_name: '',
        fileUrl: '',
        name: '',
        description: '',
        available: true,
        featured: false,
        file: '',
        images: [],
        price: 0,
        discount: 0,
        weight: 0,
      },
      variants: [],
      deletedVariants: [],
      dialog2: false,
      dialog1: false,
      valid: false,
      valid1: false,
      confirm: false,
      imgMode: 'upload',
    };
  },

  methods: {
    addImage(img) {
      let main = false;
      if (!this.images.length) main = true;
      this.images.push({ file: img, main });
      this.$refs.fileInput.$el.value = '';
    },

    reload() {
      let loader = this.$loading.show();
      this.loadProducts();
      api.get('categories').then(r => {
        this.categories = r.data;
        loader.hide();
        r.data.forEach(i => {
          this.categoriesItems.push(i);
        });
      });
      // if (!Object.keys(this.gallery).length)
      //   api.get("gallery").then((r) => {
      //     this.gallery = r.data;
      //   });
    },
    submit() {
      if (this.editProduct) this.updateProduct();
      else this.addProduct();
    },
    loadProducts() {
      let loader = this.$loading.show();
      if (this.category.id == 'all') {
        api
          .get('products')
          .then(r => {
            this.products = r.data;
            loader.hide();
          })
          .catch(async err => {
            loader.hide();
            if (err.message == 'Network Error') {
              const res = await this.$dialog.confirm({
                text: 'Please check your internet connection and try again',
                title: 'Connection Failed',
                actions: [
                  { text: 'Cancel', color: 'primary', key: false },
                  { text: 'Retry', color: 'primary', key: true },
                ],
              });
              if (res) {
                this.loadProducts();
              }
            }
          });
      } else {
        api
          .get(`categories/${this.category.id}/products`)
          .then(r => {
            this.products = r.data;
            loader.hide();
          })
          .catch(async err => {
            loader.hide();
            if (err.message == 'Network Error') {
              const res = await this.$dialog.confirm({
                text: 'Please check your internet connection and try again',
                title: 'Connection Failed',
                actions: [
                  { text: 'Cancel', color: 'primary', key: false },
                  { text: 'Retry', color: 'primary', key: true },
                ],
              });
              if (res) {
                this.loadProducts();
              }
            }
          });
      }
    },
    pickFile(e) {
      if (e.target.files.length > 0) {
        this.product.file = e.target.files[0];
        this.product.fileUrl = URL.createObjectURL(this.product.file);

        this.uploadImage(this.product.file);
      }
    },
    async uploadImage(file) {
      this.uploading = true;
      let formData = new FormData();
      formData.append('image', file);
      const r = await api.post('upload/file', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: progressEvent =>
          (this.progress = progressEvent.total),
      });

      this.uploading = false;
      return r.data.file_url;
    },
    addVariant(v) {
      if (!this.editVariant) this.variants.push(v);
      else {
        this.variants.splice(this.editVariantIndex, 1, v);
        this.editVariant = false;
        this.variant = {};
      }
      this.variantDialog = false;
    },
    removeVariant(i) {
      if (this.variants.length > 1) {
        this.deletedVariants.push(...this.variants.splice(i, 1));
      } else
        this.$dialog.error({
          text: 'Cannot delete this item',
          title: 'Error',
        });
    },
    async addProduct() {
      if (this.valid) {
        let loader = this.$loading.show();
        try {
          const images = await Promise.all(
            this.images.map(async img => {
              if (img.file instanceof File) {
                const url = await this.uploadImage(img.file);
                img.url = url;
                delete img.file;
              }
              return img;
            }),
          );
          api
            .post('products', {
              images: images,
              name: this.product.name,
              description: this.product.description,
              price: this.product.price,
              discount: this.product.discount,
              available: this.product.available,
              featured: this.product.featured,
              category_id: this.product.category_id,
              weight: this.product.weight,
            })
            .then(async r => {
              if (this.variants.length) {
                await api.post(`variants/${r.data.id}`, {
                  variants: this.variants,
                });
              }

              loader.hide();
              this.loadProducts();
              this.dialog = false;
              this.resetForm();
            });
        } catch (err) {
          loader.hide();
          this.dialog2 = true;
        }
      }
    },
    setEditProduct() {
      var c = this.selectedProducts[0];
      this.product.id = c.id;
      this.product.name = c.name;
      this.product.price = c.price;
      this.product.discount = c.discount;
      this.product.category_id = c.category_id;
      this.variants = c.variants;
      this.product.featured = c.featured;
      this.product.available = c.available;
      this.product.description = c.description;
      this.product.weight = c.weight;
      this.images = c.images;
      this.valid = false;
      this.editProduct = true;
      this.dialog = true;
    },
    cancel() {
      this.dialog = false;
      this.editProduct = false;
      this.resetForm();
    },
    updateAvailable(id, v) {
      let loader = this.$loading.show();
      api
        .put('products/' + id, { available: v })
        .then(function(r) {
          loader.hide();
        })
        .catch(async err => {
          loader.hide();
          if (err.message == 'Network Error') {
            const res = await this.$dialog.confirm({
              text: 'Please check your internet connection and try again',
              title: 'Connection Failed',
              actions: [
                { text: 'Cancel', color: 'primary', key: false },
                { text: 'Retry', color: 'primary', key: true },
              ],
            });
            if (res) {
              this.updateAvailable(id, v);
            }
          }
        });
    },
    updateFeatured(id, v) {
      let loader = this.$loading.show();
      api
        .put('products/' + id, { featured: v })
        .then(function(r) {
          loader.hide();
        })
        .catch(async err => {
          loader.hide();
          if (err.message == 'Network Error') {
            const res = await this.$dialog.confirm({
              text: 'Please check your internet connection and try again',
              title: 'Connection Failed',
              actions: [
                { text: 'Cancel', color: 'primary', key: false },
                { text: 'Retry', color: 'primary', key: true },
              ],
            });
            if (res) {
              this.updateFeatured(id, v);
            }
          }
        });
    },
    async updateProduct() {
      if (this.valid) {
        let loader = this.$loading.show();
        try {
          const images = await Promise.all(
            this.images.map(async img => {
              if (img.file instanceof File) {
                const url = await this.uploadImage(img.file);
                img.url = url;
                delete img.file;
              }
              return img;
            }),
          );
          api
            .put('products/' + this.product.id, {
              images: images,
              name: this.product.name,
              description: this.product.description,
              price: this.product.price,
              discount: this.product.discount,
              available: this.product.available,
              featured: this.product.featured,
              category_id: this.product.category_id,
              weight: this.product.weight,
            })
            .then(r => {
              const newVaraints = this.variants.filter(v => !v.id);
              const requests = [
                ...this.variants
                  .filter(v => v.id)
                  .map(v => api.put(`variants/${v.id}`, v)),
              ];

              requests.push(
                ...this.deletedVariants
                  .filter(v => v.id && v.product_id === this.product.id)
                  .map(v => api.delete('variants/' + v.id)),
              );
              if (newVaraints.length)
                requests.push(
                  api.post(`variants/${r.data.id}`, {
                    variants: newVaraints,
                  }),
                );
              Promise.all(requests).then(v => {
                loader.hide();
                this.loadProducts();
                this.dialog = false;
                this.resetForm();
              });
            });
        } catch (err) {
          loader.hide();
          this.dialog2 = true;
        }
      }
    },
    async deleteProducts() {
      var res = await this.$dialog.confirm({
        text: 'Do you really want to delete?',
        title: 'Warning',
      });
      if (res) {
        let loader = this.$loading.show();
        var deletedIds = [];
        this.selectedProducts.forEach(p => deletedIds.push(p.id));
        api
          .post('products/delete', { deletedIds })
          .then(r => {
            loader.hide();
            this.loadProducts();
            this.selectedProducts = [];
          })
          .catch(async err => {
            loader.hide();
            if (err.message == 'Network Error') {
              const res = await this.$dialog.confirm({
                text: 'Please check your internet connection and try again',
                title: 'Connection Failed',
                actions: [
                  { text: 'Cancel', color: 'primary', key: false },
                  { text: 'Retry', color: 'primary', key: true },
                ],
              });
              if (res) {
                this.deleteProducts();
              }
            }
          });
      }
    },
    resetForm() {
      this.product = {
        category_id: '',
        name: '',
        description: '',
        available: true,
        featured: false,
        file: '',
        images: [],
        price: 0,
        discount: 0,
        wieght: 0,
      };
      this.variants = [];
      this.images = [];
      this.deletedVariants = [];
      this.step = 0;
    },

    imgUrl(img) {
      if (img instanceof File) return URL.createObjectURL(img);
      return file;
    },
    updateMainImg(e, img) {
      img.main = e.target.checked;
      this.images.forEach(i => {
        if (i.url !== img.url) i.main = false;
      });
    },
  },
  watch: {
    vid: {
      handler(v) {
        if (v) this.reload();
      },
      immediate: true,
    },
    images() {
      if (this.images.length && !this.images.some(img => img.main))
        this.images[0].main = true;
    },
  },
  computed: {
    vid() {
      return this.$store.state.vid;
    },
  },
  created() {
    this.headers = [
      {
        sortable: false,
        text: 'Image',
        value: 'image',
        align: 'center',
      },
      {
        sortable: true,
        text: 'Name',
        value: 'name',
        align: 'left',
      },
      {
        sortable: true,
        text: 'Price',
        value: 'price',
        align: 'left',
      },
      {
        sortable: true,
        text: 'Discount',
        value: 'discount',
        align: 'left',
      },
      {
        sortable: true,
        text: 'Available/Featured',
        value: 'available',
        align: 'left',
      },

      {
        sortable: false,
        text: 'Variants',
        align: 'center',
      },
    ];
  },
  components: { VImageInput },
};
</script>
